import React, { Component } from "react";
import styles from "./ProgressTracker.module.scss";
import sharedStyles from "../OrderDetailsNewVersion.module.scss";
import { withTranslation } from "react-i18next";
import UpperCaseText from "../../../../utils/UpperCaseText";
import LowerCaseText from "../../../../utils/LowerCaseText";
import crStyles from "../../../customerReservation/crStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import {
  IS_AGENT_DEALERTYPE,
  IS_ITALY_MARKET,
} from "../../../../utils/EmpUtil";
import UiDateUtils from "../../../../utils/UiDateUtils";
import Grid from "@material-ui/core/Grid";
import { HANDOVER_STATUS } from "../handOver/Constants";
import {
  CANCELLED,
  GOMS_FLOW_STATUS,
  ORDER_STATUS,
  RESERVATION_STATUS,
  SAP_ORDER_STATUS,
} from "../../../../common/Constants";
import SharedToolTip from "../../../../shared/sharedToolTip/SharedToolTip";

class ProgressTracker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandProgressTracker: true,
      steps: [],
      emailStatus: {},
      language: localStorage.getItem("lang"),
      progressTrackerToolTipOpen: false,
    };

    this.preOrderPlacedStatuses = this.props.preOrderPlacedStatuses;
    this.cancelledStatuses = [
      "DEALER_CANCELLED",
      "CONTRACT_CANCELLED",
      "RESERVATION_CANCELLED",
      "ORDER_CANCELLED",
      "DEALER_REJECTED",
      "CANCELLED",
      "CONTRACT_CANCEL_REQUESTED",
    ];
    this.orderCompleted = ["COMPLETED"];
  }

  componentDidMount() {
    this.setState({
      steps: this.getSteps(),
      emailStatus: this.getEmailStatus(),
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.language !== localStorage.getItem("lang") ||
      prevProps.reservation !== this.props.reservation
    ) {
      this.setState({
        steps: this.getSteps(),
        emailStatus: this.getEmailStatus(),
        language: localStorage.getItem("lang"),
      });
    }
  }

  getSteps() {
    this.allActiveReservationStepsForItaly = [
      {
        number: 1,
        name: this.props.t("ProgressTracker.orderPlacedEU"),
        style: styles.active,
      },
      {
        number: 2,
        name: this.props.t("ProgressTracker.inProductionEU"),
        style: styles.active,
      },
      {
        number: 3,
        name: this.props.t("ProgressTracker.shippingEU"),
        style: styles.active,
      },
      {
        number: 4,
        name: this.props.t("ProgressTracker.deliveredEU"),
        style: styles.active,
      },
    ];
    this.allActiveReservationSteps = [
      {
        number: 1,
        name: this.props.t("ProgressTracker.reservationPlacedEU"),
        style: styles.active,
      },
      {
        number: 2,
        name: this.props.t("ProgressTracker.orderPlacedEU"),
        style: styles.active,
      },
      {
        number: 3,
        name: this.props.t("ProgressTracker.inProductionEU"),
        style: styles.active,
      },
      {
        number: 4,
        name: this.props.t("ProgressTracker.shippingEU"),
        style: styles.active,
      },
      {
        number: 5,
        name: this.props.t("ProgressTracker.deliveredEU"),
        style: styles.active,
      },
    ];
    this.allActiveOrderSteps = [
      {
        number: 1,
        name: this.props.t("ProgressTracker.orderPlacedEU"),
        style: styles.active,
      },
      {
        number: 2,
        name: this.props.t("ProgressTracker.inProductionEU"),
        style: styles.active,
      },
      {
        number: 3,
        name: this.props.t("ProgressTracker.shippingEU"),
        style: styles.active,
      },
      {
        number: 4,
        name: this.props.t("ProgressTracker.deliveredEU"),
        style: styles.active,
      },
    ];
    this.allDisabledReservationSteps = [
      {
        number: 1,
        name: this.props.t("ProgressTracker.reservationPlacedEU"),
        style: "",
      },
      {
        number: 2,
        name: this.props.t("ProgressTracker.orderPlacedEU"),
        style: "",
      },
      {
        number: 3,
        name: this.props.t("ProgressTracker.inProductionEU"),
        style: "",
      },
      {
        number: 4,
        name: this.props.t("ProgressTracker.shippingEU"),
        style: "",
      },
      {
        number: 5,
        name: this.props.t("ProgressTracker.deliveredEU"),
        style: "",
      },
    ];
    this.allDisabledOrderSteps = [
      {
        number: 1,
        name: this.props.t("ProgressTracker.orderPlacedEU"),
        style: "",
      },
      {
        number: 2,
        name: this.props.t("ProgressTracker.inProductionEU"),
        style: "",
      },
      {
        number: 3,
        name: this.props.t("ProgressTracker.shippingEU"),
        style: "",
      },
      {
        number: 4,
        name: this.props.t("ProgressTracker.deliveredEU"),
        style: "",
      },
    ];

    const isReservation =
      UpperCaseText(this.props.reservation.orderType) === "RESERVATION";
    const wasReservation = this.props.reservation.conversionDate;
    const isCancelled = this.cancelledStatuses.includes(
      this.props.reservation.status
    );
    const isCompleted = this.orderCompleted.includes(
      this.props.reservation.status
    );
    if (isCancelled) {
      if (isReservation || wasReservation) {
        return this.getCancelledReservationSteps(
          LowerCaseText(this.props.reservation.vehicleStatusCode),
          this.props.reservation.status,
          wasReservation
        );
      } else {
        return this.getCancelledOrderSteps(
          LowerCaseText(this.props.reservation.vehicleStatusCode),
          this.props.reservation.status
        );
      }
    } else if (isCompleted) {
      return this.getCompletedOrderSteps(
        this.props.reservation.status,
        isCompleted
      );
    } else {
      if (isReservation || wasReservation) {
        return this.getReservationSteps(
          LowerCaseText(this.props.reservation.vehicleStatusCode),
          wasReservation
        );
      } else {
        return this.getOrderSteps(
          LowerCaseText(this.props.reservation.vehicleStatusCode)
        );
      }
    }
  }

  getEmailStatus() {
    const status = UpperCaseText(this.props.reservation.status);
    const vehicleStatusCode = UpperCaseText(
      this.props.reservation.vehicleStatusCode
    );
    const emailStatus = {};
    // welcome will be shown once the order status is completed
    emailStatus.welcome = this.orderCompleted.includes(
      this.props.reservation.status
    );
    //book handover is a step which emp triggers
    emailStatus.bookHandover =
      this.props.reservation.handoverappointmentConfirmedData &&
      this.props.reservation.handoverappointmentConfirmedData
        .appointmentInfoData &&
      this.props.reservation.handoverappointmentConfirmedData.appointmentInfoData.filter(
        (appointment) =>
          appointment.appointmentStatus === HANDOVER_STATUS.INITIAL ||
          appointment.appointmentStatus === HANDOVER_STATUS.ACCEPTED
      ).length > 0;
    //pre handover once the status comes to VAFD which index is 22
    emailStatus.preHandover = GOMS_FLOW_STATUS.indexOf(vehicleStatusCode) >= 22;
    //check of the Customs clearance date exists in SAP response
    emailStatus.closerNow = !!this.props.reservation.customsClearanceDate;
    //on its way start once the status comes to VITR which index is 13
    emailStatus.onItsWay = GOMS_FLOW_STATUS.indexOf(vehicleStatusCode) >= 13;
    //in prod will be active once the status reaches STRT which is in index 6
    emailStatus.inProduction =
      emailStatus.onItsWay || GOMS_FLOW_STATUS.indexOf(vehicleStatusCode) >= 6;
    //order status should not be cancelled||created||contract Requested
    emailStatus.orderConfirmed =
      status !== SAP_ORDER_STATUS.CANCELLED &&
      status !== SAP_ORDER_STATUS.CREATED &&
      status !== SAP_ORDER_STATUS.CONTRACT_REQUESTED;
    //by default it will be true other than cancelled
    emailStatus.orderReceived = true;

    return emailStatus;
  }

  addReservationSteps(index, cancelled) {
    const allSteps = [];

    for (let i = 0; i < 5; i++) {
      if (i > index && cancelled) {
        break;
      } else if (i > index) {
        allSteps.push(this.allDisabledReservationSteps[i]);
      } else {
        IS_ITALY_MARKET(this.props.market)
          ? allSteps.push(this.allActiveReservationStepsForItaly[i])
          : allSteps.push(this.allActiveReservationSteps[i]);
      }
    }

    return allSteps;
  }

  getReservationSteps(status, wasReservation) {
    let index = wasReservation ? 1 : 0;
    if (status) {
      index = this.getIndex(status, false);
    }
    index = index === undefined ? -1 : index;
    return this.addReservationSteps(index, false);
  }

  getCancelledReservationSteps(status, cancelStatus, wasReservation) {
    let index = wasReservation ? 1 : 0;

    if (status) {
      index = this.getIndex(status, false);
    }

    const steps = this.addReservationSteps(index, true);

    steps.push({
      number: index + 2,
      name: this.props.t("ProgressTracker.cancelledEU"),
      style: styles.active,
    });

    return steps;
  }

  addOrderSteps(index, cancelled) {
    const allSteps = [];

    for (let i = 0; i < 4; i++) {
      if (i > index && cancelled) {
        break;
      } else if (i > index) {
        allSteps.push(this.allDisabledOrderSteps[i]);
      } else {
        allSteps.push(this.allActiveOrderSteps[i]);
      }
    }

    return allSteps;
  }

  getIndex(status, type) {
    if (type) {
      for (const [key, value] of Object.entries(ORDER_STATUS)) {
        for (let i = 0; i < value.length; i++) {
          if (value[i] === status) {
            return parseInt(key);
          }
        }
      }
    } else {
      for (const [key, value] of Object.entries(RESERVATION_STATUS)) {
        for (let i = 0; i < value.length; i++) {
          if (value[i] === status) {
            return parseInt(key);
          }
        }
      }
    }
  }

  getOrderSteps(status) {
    let index = 0;
    if (status) {
      index = this.getIndex(status, true);
    }
    return this.addOrderSteps(index, false);
  }

  getCancelledOrderSteps(status) {
    let index = 0;

    if (status) {
      index = this.getIndex(status, true);
    }

    const steps = this.addOrderSteps(index, true);

    steps.push({
      number: index + 2,
      name: this.props.t("ProgressTracker.cancelledEU"),
      style: styles.active,
    });

    return steps;
  }

  getCompletedOrderSteps(status, isCompleted) {
    let index = 0;
    if (isCompleted) {
      index = this.getIndex(status, true);
    }

    return this.addOrderSteps(index, false);
  }

  getStyle(currentStatusIndex, stepIndex) {
    return currentStatusIndex >= stepIndex ? styles.active : "";
  }

  getInfo() {
    const vista = this.props.reservation.vistaOrderNumber;
    const orbit = this.props.reservation.orbitId;
    const created = this.props.reservation.orbitIdCreatedDate;
    return (
      <div className={styles.subheaderDiv}>
        {vista && (
          <div className={styles.subheaderText}>
            {this.props.t("ProgressTracker.addedToVista")}
          </div>
        )}
        <div className={styles.subheaderTextBold}>
          {vista && (
            <span>
              {this.props.t("ProgressTracker.vista")}
              {vista}
            </span>
          )}
          {vista && orbit && <span>&nbsp;|&nbsp;</span>}
          {orbit && (
            <span>
              {this.props.t("ProgressTracker.orbit")}
              {orbit}
            </span>
          )}
          {(vista || orbit) && created && (
            <span>
              &nbsp;({this.props.t("ProgressTracker.entered")}{" "}
              {created.replace(/-/gi, "/")})
            </span>
          )}
          {this.props.message && this.props.message.body}
        </div>
      </div>
    );
  }

  getCancelledInfo(status) {
    let cancelledByUser = "";
    let cancelledDate = "";
    const cancelledBy =
      status === "DEALER_CANCELLED" || status === "CONTRACT_CANCEL_REQUESTED"
        ? IS_AGENT_DEALERTYPE(this.props.dealerType)
          ? this.props.t("ProgressTracker.agent")
          : this.props.t("ProgressTracker.dealer")
        : this.props.t("ProgressTracker.consumer");
    if (
      (status === "DEALER_CANCELLED" ||
        status === "CONTRACT_CANCEL_REQUESTED") &&
      this.props.reservation.orderDetailsDealerAction &&
      this.props.reservation.orderDetailsDealerAction.dealerAction &&
      UpperCaseText(
        this.props.reservation.orderDetailsDealerAction.dealerAction
      ) === CANCELLED
    ) {
      cancelledByUser =
        this.props.reservation.orderDetailsDealerAction.dealerActionUserId;
      cancelledDate =
        this.props.reservation.orderDetailsDealerAction.dealerActionDate;
    } else if (
      status === "ORDER_CANCELLED" ||
      status === "RESERVATION_CANCELLED"
    ) {
      cancelledDate =
        this.props.reservation &&
        this.props.reservation.cancellation &&
        this.props.reservation.cancellation.cancellationDate;
    }
    return (
      <div className={styles.subheaderDiv}>
        <div className={styles.subheaderTextBold}>
          {this.props.t("ProgressTracker.cancelledBy")} {cancelledBy}
          {cancelledByUser !== "" && " - "}
          {cancelledByUser}
          {cancelledDate !== "" && " - "}
          {UiDateUtils.formatYYYYMMDDToEUWithoutTime(cancelledDate)}
        </div>
        <div className={styles.subheaderText}>
          {this.props.message && this.props.message.body}
        </div>
      </div>
    );
  }

  getCompletedInfo(status) {
    const completedInfo =
      status === "COMPLETED"
        ? this.props.t("ProgressTracker.deliveredEU")
        : this.props.t("ProgressTracker.bookHandover");
    return (
      <div className={styles.subheaderDiv}>
        <div className={styles.subheaderTextBold}>{completedInfo}</div>
      </div>
    );
  }

  getEmailStatusInfo(condition, name) {
    return (
      <div className={styles.emailTextStyle}>
        <div>
          <div className={condition ? styles.success : styles.yetToBeSuccess} />
        </div>
        <div>
          <div className={styles.currentStep}>{name}</div>
        </div>
      </div>
    );
  }

  toggleProgressTrackerToolTip = (event) => {
    event.stopPropagation();
    this.setState((prevState) => ({
      progressTrackerToolTipOpen: !prevState.progressTrackerToolTipOpen,
    }));
  };

  expandProgressTracker() {
    this.setState({
      expandProgressTracker: !this.state.expandProgressTracker,
    });
  }

  render() {
    const orderCancelled = this.cancelledStatuses.includes(
      this.props.reservation.status
    );
    const orderCompleted = this.orderCompleted.includes(
      this.props.reservation.status
    );

    return (
      <StyledBasicExpansionPanel
        defaultExpanded={true}
        onChange={() => this.expandProgressTracker()}
      >
        <StyledBasicExpansionPanelSummary style={crStyles.headerBarNeutral}>
          <div className={sharedStyles.headerBar}>
            <div className={sharedStyles.boldHeaderWithToolTip}>
              {this.props.t("ProgressTracker.header")}
              <SharedToolTip
                openTestid="progressTrackerToolTipOpen"
                open={this.state.progressTrackerToolTipOpen}
                closeTooltip={this.toggleProgressTrackerToolTip}
                openTooltip={this.toggleProgressTrackerToolTip}
                body={this.props.t("ProgressTracker.toolTip")}
              />
            </div>
            <div>
              {this.state.expandProgressTracker ? (
                <ExpandLessIcon id="less" />
              ) : (
                <ExpandMoreIcon id="more" />
              )}
            </div>
          </div>
          <br />
        </StyledBasicExpansionPanelSummary>
        <div className={styles.bottomBorder}></div>
        <div className={styles.progressTrackerWrapper}>
          <div
            className={
              orderCancelled
                ? styles.progressBarCancelled
                : styles.progressBar || orderCompleted
                ? styles.progressBar
                : ""
            }
          >
            {this.state.steps.map((step, index) => {
              return (
                <div className={styles.navTab} key={index}>
                  {index > 0 ? (
                    <div className={styles.connectingLine}>
                      <span className={step.style}>&nbsp;</span>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className={styles.navStepButton}>
                    <div
                      className={`${styles.progressTabNumber} ${step.style}`}
                    >
                      <span
                        data-testid={`${step.style}${step.number}`}
                        className={`${styles.stepNumber} ${step.style}`}
                      >
                        {step.number}
                      </span>
                    </div>
                    <div className={`${styles.progressTab} ${step.style}`}>
                      {step.name}
                    </div>

                    {!orderCancelled && index > 0 ? (
                      <div className={styles.verticalLine} />
                    ) : (
                      ""
                    )}
                    {!orderCancelled && (
                      <Grid>
                        {index === 0 ? (
                          <>
                            {this.getEmailStatusInfo(
                              this.state.emailStatus.orderReceived,
                              this.props.t("ProgressTracker.orderReceived")
                            )}
                            {this.getEmailStatusInfo(
                              this.state.emailStatus.orderConfirmed,
                              this.props.t("ProgressTracker.orderConfirmed")
                            )}
                          </>
                        ) : index === 1 ? (
                          <>
                            {this.getEmailStatusInfo(
                              this.state.emailStatus.inProduction,
                              this.props.t("ProgressTracker.inProduction")
                            )}
                          </>
                        ) : index === 2 ? (
                          <div className={styles.shippingBox}>
                            {this.getEmailStatusInfo(
                              this.state.emailStatus.onItsWay,
                              this.props.t("ProgressTracker.onItsWay")
                            )}
                            {this.getEmailStatusInfo(
                              this.state.emailStatus.closerNow,
                              this.props.t("ProgressTracker.closerNow")
                            )}
                            {this.getEmailStatusInfo(
                              this.state.emailStatus.preHandover,
                              this.props.t("ProgressTracker.preHandover")
                            )}
                            {this.getEmailStatusInfo(
                              this.state.emailStatus.bookHandover,
                              this.props.t("ProgressTracker.bookHandover")
                            )}
                          </div>
                        ) : (
                          index === 3 && (
                            <>
                              {this.getEmailStatusInfo(
                                this.state.emailStatus.welcome,
                                this.props.t("ProgressTracker.welcome")
                              )}
                            </>
                          )
                        )}
                      </Grid>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          {orderCancelled
            ? this.getCancelledInfo(this.props.reservation.status)
            : this.getInfo()}
          {orderCompleted
            ? this.getCompletedInfo(this.props.reservation.status)
            : ""}
        </div>
      </StyledBasicExpansionPanel>
    );
  }
}

export default withTranslation("emp")(ProgressTracker);
